import { toScenePoint } from "../konva/scene/viewport.js";
import { camelCase, range, upperFirst } from "es-toolkit";
//#region src/utils/index.ts
var toZIndex = (data) => data.ui.zIndex;
var nextZIndex = (tables, memos) => Math.max(1, ...tables.map(toZIndex), ...memos.map(toZIndex)) + 1;
var isSamePoint = (a) => (b) => a.y === b.y && a.x === b.x;
function nextPoint(settings, tables, memos) {
	const point = toScenePoint(settings, {
		x: 200,
		y: 100
	});
	const points = [...tables, ...memos].map(({ ui }) => ui);
	while (points.some(isSamePoint(point))) {
		point.x += 50;
		point.y += 50;
	}
	return point;
}
function safeRange(a, b) {
	return a < b ? range(a, b + 1) : range(b, a + 1);
}
function pascalCase(value) {
	return upperFirst(camelCase(value ?? ""));
}
//#endregion
export { nextPoint, nextZIndex, pascalCase, safeRange };
